import React, { useContext } from 'react';
import RadioGroupContext from './context';
import classNames from 'classnames';
import BaseCheckbox from '../checkbox/BaseCheckbox';
const BaseRadio = ({ prefixCls = 'radio', children, ...props }) => {
    const groupContext = useContext(RadioGroupContext);
    const onChange = (e) => {
        props.onChange?.(e);
        groupContext?.onChange?.(e);
    };
    const radioProps = {
        ...props,
    };
    if (groupContext) {
        radioProps.checked = props.value === groupContext.value;
        radioProps.onChange = onChange;
    }
    const wrapperClassString = classNames(`${prefixCls}-wrapper`, {
        [`${prefixCls}-wrapper-checked`]: radioProps.checked,
        [`${prefixCls}-wrapper-disabled`]: radioProps.disabled,
    });
    return (React.createElement("label", { className: wrapperClassString },
        React.createElement(BaseCheckbox, { type: 'radio', prefixCls: prefixCls, ...radioProps }),
        children !== undefined && React.createElement("span", { className: `${prefixCls}-content` }, children)));
};
if (process.env.NODE_ENV !== 'production') {
    BaseRadio.displayName = 'BaseRadio';
}
export default BaseRadio;
//# sourceMappingURL=BaseRadio.js.map